import ol = require("ol");
import $ = require("jquery");
import _ = require("underscore");
import b = require("backbone");
import Portal = require("portal-gis");
import Utils = require("../utils");
import IPS = require("publicsector");
import Base = require("./base-command");
import Symbology = require("../utils/symbology");

class Command extends Base<{
    in: any;
    out: {
        selected: Rhythm.GIS.FeatureQueryResultFeature[];
        unselected: Rhythm.GIS.FeatureQueryResultFeature[];
    }
}> {

    static about = `Highlights "selected" features, removes highlight from "unselected" features.`;

    // these are the options that can be overridden via configuration
    static options = {
        symbology: 'Style to use when rendering highlighted features'
    };

    // this is the output of the triggering event (used as input) 
    static input = {
        selected: 'the features that need to be selected',
        unselected: 'the features that need to be unselected'
    }

    static defaults = {
        symbology: "hilite"
    };

    // un/highlight selected features by removing/adding style
    execute(args = this.args) {

        let options = _.defaults(this.options, Command.defaults);

        let style = Symbology.findStyle(this.mediator, options["symbology"]);

        args.out.selected.forEach(f => this.highlight(f, style, false));
        args.out.unselected.forEach(f => this.highlight(f, style, true));
        this.trigger();
    }

    private highlight(f: Rhythm.GIS.FeatureQueryResultFeature, highlightStyle: ol.style.Style, remove = false) {
        let feature = <ol.Feature>this.mediator.extend(f).olFeature;
        if (!feature) {
            console.log("highlight: could not identify the map feature");
            return;
        }

        let style = <Array<ol.style.Style>>feature.getStyle();
        if (!style) {
            console.warn("feature without a style!");
            style = [];
        } else
            if (!$.isArray(style)) {
                if (remove) return;
                style = <any>[style];
            }

        let styleId = this.options["symbology"];

        if (remove) {
            style = style.filter(s => !Utils.extend(s)[styleId]);
        }
        else {
            if (!style.some(s => Utils.extend(s)[styleId])) {
                Utils.extend(highlightStyle)[styleId] = true;
                style.push(highlightStyle);
            } else {
                console.log("already highlighted");
            }
        }

        feature.setStyle(style);
    }

}

export = Command;